import React, {Component} from 'react';
import {Button, Form} from 'react-bootstrap';
import {createForm} from "../../util/form";
import {inject, observer} from 'mobx-react';

@inject('EventStore')
@observer
export class PersonRegisterForm extends Component {
    constructor(props) {
        super(props);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.memberFormsBuilder = [
            {
                label: 'รหัสสมาชิก',
                name: 'mcode',
                type: 'text',
                bsClass: 'form-control',
                placeholder: 'รหัสสมาชิก หรือ ชื่อ-นามสกุล ผุ้แนะนำ',
            },
        ];
        this.memberAltFormsBuilder = [
            {
                label: 'ชื่อ',
                name: 'mName',
                type: 'text',
                bsClass: 'form-control',
                placeholder: 'ชื่อ',
            },
            {
                label: 'นามสกุล',
                name: 'mSName',
                type: 'text',
                bsClass: 'form-control',
                placeholder: 'นามสกุล',
            },
        ];

        this.state = {
            validate: false,
            validateList: {}
        }
        this.memberFormsBuilder.map(x => this.state.validateList[x.name] = false);
        this.memberAltFormsBuilder.map(x => this.state.validateList[x.name] = false);

    }

    onFilldata(event) {
        const {target} = event;
        event.preventDefault();
        console.log('test');
        if (target.value !== '') {
            this.state.validateList[target.name] = true;
        } else {
            this.state.validateList[target.name] = false;
        }
        ;
        this.setState({...this.state});
        return;
    }

    handleSubmit(event) {
        event.preventDefault();
        const formData = event.target;
        const reMember = formData.mcode.value.split(' ');
        let rMember = {};
        if (reMember.length === 1) {
            if (reMember[0] !== '') {
                rMember['member_code'] = reMember[0];
            } else {
                rMember = null;
            }
        } else if (reMember.length > 1) {
            rMember['name'] = reMember[0];
            rMember['surname'] = reMember[1];
        } else {
            rMember = null;
        }
        const body = {
            type: 'person',
            person: {
                name: formData.mName.value,
                surname: formData.mSName.value,
                recommender: rMember
            }
        };

        this.props.EventStore.register(body);
        return;
    }

    getEvent() {
        if (this.props.EventStore.event) {
            return (
                    <p>{this.props.EventStore.event.name}</p>
        );
        }
    }

    render() {
        return (
            <div className="member-register-form">
                <Form onSubmit={this.handleSubmit}>
                    <div className="form-header">
                        {this.getEvent()}
                        <h4>กรุณากรอกข้อมูล</h4>
                    </div>
                    <div className="form-body">
                        {createForm(this.memberAltFormsBuilder)}
                    </div>
                    <div className="form-option">
                        <h4>
                            <span>ผู้แนะนำเข้างาน</span>
                        </h4>
                    </div>
                    <div className="form-body">
                        {createForm(this.memberFormsBuilder)}
                    </div>
                    <div className="form-footer">
                        <Button
                            type='submit'
                            bsStyle='primary' fill
                        >
                            ลงทะเบียน
                        </Button>
                    </div>
                </Form>
            </div>

        )
    }


}

export default PersonRegisterForm;


// WEBPACK FOOTER //
// ./src/component/event/RegisterPersonForm.jsx